import request from '../../shared/request'

export function getRevisions({ target_id, table }) {
  return request(`/revisions?targetId=${target_id}&table=${table}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/revision.js